import { apiClient, HOST } from "api/apiClient";
import {
  addComparisonData,
  addVideo,
  addVideos,
  getBanners,
  getCities,
  getFaqs,
  getFeatureImages,
  getLocations,
  getProducts,
  getRefund,
  getStates,
  getTeams,
  getTerms,
  getTrucks,
} from "store/actions";
import { sortData } from "utils";

export const fetchBanners = () => async (dispatch) => {
  apiClient.getBanners().then((banners) => {
    dispatch(getBanners(banners.data[0].attributes.banners.data));
  });
};

export const fetchFaqs = () => async (dispatch) => {
  apiClient.getFaqs().then((faqs) => {
    const faqData = faqs.data.map((item, i) => ({
      id: i,
      description: item.attributes.description,
      title: item.attributes.title,
    }));

    dispatch(getFaqs(faqData));
  });
};
export const fetchTrucks = () => async (dispatch) => {
  apiClient.getHiloads().then((loads) => {
    dispatch(getTrucks(loads?.data[0]?.attributes.hiloads));
  });
};

export const fetchTerms = () => async (dispatch) => {
  apiClient.getTermsOfUse().then((res) => {
    dispatch(
      getTerms({
        terms: res?.data,
      })
    );
  });
};

export const fetchRefund = () => async (dispatch) => {
  apiClient.getRefund().then((res) => {
    dispatch(
      getRefund({
        refund: res.data[0].attributes?.refund,
        media: res.data[0].attributes.media.data.attributes.url,
        alt: res.data[0].attributes.media.data.attributes.alternativeText,
      })
    );
  });
};

export const fetchVideo = () => async (dispatch) => {
  apiClient.getVideo().then((res) => {
    dispatch(
      addVideo(HOST + res?.data[0]?.attributes?.euler_video?.data?.attributes?.url || res?.data[0]?.attributes?.url)
    );
    dispatch(addVideos(res.data));
  });
};

export const fetchFeatureImages = (lng) => async (dispatch) => {
  apiClient.getFeatureImages(lng).then((res) => {
    dispatch(getFeatureImages(res?.data));
  });
};

export const fetchTeams = () => async (dispatch) => {
  apiClient.getTeams().then((res) => {
    dispatch(getTeams(res?.data));
  });
};

export const fetchProducts = () => async (dispatch) => {
  apiClient.getProducts().then((res) => {
    dispatch(getProducts(sortData(res?.data)));
  });
};

export const fetchComparisonData = () => async (dispatch) => {
  apiClient.getComparison().then((res) => {
    dispatch(addComparisonData(res.data[0]?.attributes));
  });
};

export const fetchCities = () => async (dispatch) => {
  apiClient.getChargingNetworkCities().then((res) => {
    dispatch(getCities(res.data));
  });
};

export const fetchStates = () => async (dispatch) => {
  apiClient.getChargingNetworkStates().then((res) => {
    dispatch(getStates(res.data));
  });
};

export const fetchLocations = () => async (dispatch) => {
  apiClient.getLocations().then((res) => {
    dispatch(getLocations(res.data));
  });
};
